import { Outlet, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Header } from '@/components/common/Header';
import { UserAccountMenu } from '@/components/common/UserAccountMenu';
import { getSafePath } from '@/lib/urlUtils';
import { trackEvent } from '@/api/track';
import { useDashboardStore } from '@/store/useDashboardStore';

/**
 * DashboardLayout 布局组件
 * 为所有管理类页面（控制面板、账户设置、计费等）提供统一的导航和容器
 */
const DashboardLayout = () => {
  const { t } = useTranslation('dashboard');
  const { pageCount, domainCount, liveCount, drafts } = useDashboardStore();

  const iconBtnCls =
    'flex h-[38px] w-[38px] cursor-pointer items-center justify-center rounded-[9px] border border-black/[0.07] bg-white text-[14px] text-foreground/60 transition-all duration-200 hover:border-black/[0.18] hover:text-foreground no-underline';

  /** 顶栏右侧内容：动作按钮、通知及用户菜单 */
  const rightContent = (
    <div className="flex items-center gap-[10px]">
      {/* New page 按钮 */}
      <Link
        to={getSafePath('/create')}
        onClick={() =>
          trackEvent({
            eventCode: 'dashboard_new_page_click',
            eventData: JSON.stringify({
              entryPosition: 'header',
              route: '/dashboard',
              pageCount,
              domainCount,
              liveCount,
              draftCount: drafts.length,
            }),
          })
        }
        className="flex items-center gap-[7px] rounded-[9px] border-0 bg-[linear-gradient(135deg,#6D28D9,#0891B2)] px-[18px] py-[9px] text-[13.5px] font-bold text-white no-underline transition-opacity duration-200 hover:opacity-[.9]"
      >
        <i className="fa fa-plus" />
        {t('header.new_page')}
      </Link>

      {/* Notifications */}
      <button
        className={iconBtnCls}
        title="Notifications"
        onClick={() => toast.success('No notifications')}
      >
        <i className="fa fa-bell" />
      </button>

      {/* Help */}
      <Link to="/help" className={iconBtnCls} title="Help">
        <i className="fa fa-circle-question" />
      </Link>

      <UserAccountMenu />
    </div>
  );

  return (
    <div className="dark:bg-background text-foreground bg-background flex h-full flex-col transition-colors duration-300">
      <Header rightContent={rightContent} />

      {/* 子路由渲染区域 */}
      <main className="animate-in fade-in slide-in-from-bottom-2 mx-auto w-full px-4 pt-4 pb-16 duration-500 sm:px-6 sm:pt-6 sm:pb-20">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
